/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 var scW = $(window).width();
 
 var is_rtl = false;
 if($("body").data('direction') == 'rtl'){
  is_rtl = true;
}


if($(window).width() > 768){
  $('.collections-wrapper').lightSlider({
    gallery:false,
    item: scW > 768 ? 3 : 1,
    slideMargin: 0,
    speed:500,
    rtl: is_rtl,
    auto:false,
    controls: true,
    loop:false,
    slideMargin: scW > 768 ? 20 : 0,
    enableDrag: true,         
    onBeforeSlide: function(a, b){
      var current_slide = a.getCurrentSlideCount();
      var total_slide = a.getTotalSlideCount();

      if(current_slide == 1){
        $(".slider_arrow_wrapper .slide_arrow.slide_prev").fadeOut();
      }
      else {
        $(".slider_arrow_wrapper .slide_arrow.slide_prev").fadeIn();
      }
      if((total_slide - 2) == current_slide){
        $(".slider_arrow_wrapper .slide_arrow.slide_next").fadeOut();
      }
      else {
        $(".slider_arrow_wrapper .slide_arrow.slide_next").fadeIn();
      }
    }
  });
}

$('.videos-content').lightSlider({
  gallery:false,
  item: scW > 768 ? 3 : 1,
  slideMargin: 0,
  speed:500,
  auto:false,
  controls: false,
  loop:false,
  slideMargin: scW > 768 ? 20 : 0,
  enableDrag: true,         
});

$('.collection-title-item').click(function(){
  $('.collection-title-item.is-active').removeClass('is-active');
  $(this).addClass('is-active');
  $('.collection-item-content.is-visible').removeClass('is-visible');
  $('.collection-content-' + $(this).attr('data-id')).addClass('is-visible');
});

$('.video-item').click(function(){
  $('#video-popup .popup-video').attr('src', $(this).attr('video-url') + '?autoplay=1&mute=1');
  $('#video-popup').addClass('is-visible');
});

$('#video-popup .close').click(function(){
  $('#video-popup .popup-video').attr('src', '');
  $('#video-popup').removeClass('is-visible');
});

// console.log($('.bc-sf-filter-option-block:nth-child(1)').html());
// $('.bc-sf-filter-option-block:nth-child(1)').after('<p class="card__title--small heading filter-heading-wrapper shop-by-heading"><span class="filter-heading">Shop By<span></span></span></p>');


$(document).on('click', '.faq__question', function(){
  const target = $(this);
  if(target.attr('aria-expanded') == 'true') {
    $(this).removeClass('faq__question');
    const openedQuestion = $('.faq__question[aria-expanded=true]');
    openedQuestion.trigger('click');
    $(this).addClass('faq__question');
  }
});


$('#col-main').addClass('container');

$(document).on('DOMSubtreeModified', '#mini-cart', function(){
  const target = $(this).find('.product-recommendations-wrapper');
//     console.log(target.html());
if(target.html() == '') {
  console.log('update form');
  target.html($('.product-recommendation-section').html());
}
});

$(document).on('click', '.product-form .qty-selector__button, .product-form__info-list .qty-selector__button', function(e){
  console.log('click');
  e.preventDefault();
  e.stopPropagation();
  const target = $(this);

    if(target.data('action') == 'dec-quantity') {
      const qtyInput = target.next();
      if(parseInt(qtyInput.val()) > 1) {
        qtyInput.val(parseInt(qtyInput.val()) - 1);
      }
    } else {
      var qty = Number( target.closest("form").find(".quantity-selector__value").val() ) + 1;
      var max_qty = check_product_qty_total_price_limit (target, qty);

      if ( max_qty == 'true' ) {
          const qtyInput = target.prev();
          qtyInput.val(parseInt(qtyInput.val()) + 1);
      } else {
          const qtyInput = target.prev();
          qtyInput.val(max_qty);
      }
    }
});
function check_product_qty_total_price_limit (var_this, qty) {
  var this_form = var_this.closest("form");
  var price = this_form.find("select[name='id'] option:selected").attr("data-price");

  var cart_json = localStorage.getItem('cart_json');
  cart_json = JSON.parse(cart_json);

  var total_price_MAX = window.theme.total_price_limit * 100;
  var total_price = Number(cart_json.total_price);
  var total_price_Available = total_price_MAX - total_price;

  total_price_Available = total_price_Available / price;
  total_price_Available = Math.floor(total_price_Available);

  if ( total_price_Available < qty ) {
    if ( total_price_Available < 1 ) {
      total_price_Available = 1;
    }
    this_form.find(".total_price_limit_description").slideDown();
    setTimeout(function() {
      this_form.find(".total_price_limit_description").slideUp();
    }, 3000);
    return total_price_Available;
  } else {
    return 'true';
  }
}

$(document).on('click', '.bc-sf-filter-block-title h3', function(){
  $(this).parent().toggleClass('open');
});

$(document).on('click', '.btn-notify-me', function(e){
    // $('body').addClass('bis-popover-active');
    // $('#BIS_frame').show();
    $('.BIS_trigger').trigger('click');
  });

$(document).on('click', '.mini-cart-close, span.mini-cart-overlay', function(e){
  $('.mini-cart').attr('aria-hidden', 'true');
  $('.header__cart-toggle .icon-state__secondary').trigger('click');
});



$.fancybox.defaults.btnTpl.fb = '<button data-fancybox-fb class="fancybox-button fancybox-button--fb" title="Facebook">' +
'<svg viewBox="0 0 24 24">' +
'<path d="M22.676 0H1.324C.594 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294h-3.13v-3.62h3.13V8.41c0-3.1 1.894-4.785 4.66-4.785 1.324 0 2.463.097 2.795.14v3.24h-1.92c-1.5 0-1.793.722-1.793 1.772v2.31h3.584l-.465 3.63h-3.12V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .594 23.408 0 22.676 0"/>' +
'</svg>' +
'</button>';

// Create template for Twitter Button
$.fancybox.defaults.btnTpl.tw = '<button data-fancybox-tw class="fancybox-button fancybox-button--tw" title="Twitter">' +
'<svg viewBox="0 0 24 24">' +
'<path d="M23.954 4.57c-.885.388-1.83.653-2.825.774 1.013-.61 1.793-1.574 2.162-2.723-.95.556-2.005.96-3.127 1.185-.896-.96-2.173-1.56-3.59-1.56-2.718 0-4.92 2.204-4.92 4.918 0 .39.044.765.126 1.124C7.69 8.094 4.067 6.13 1.64 3.16c-.427.723-.666 1.562-.666 2.476 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.06c0 2.386 1.693 4.375 3.946 4.828-.413.11-.85.17-1.296.17-.314 0-.615-.03-.916-.085.63 1.952 2.445 3.376 4.604 3.416-1.68 1.32-3.81 2.105-6.102 2.105-.39 0-.78-.022-1.17-.066 2.19 1.394 4.768 2.21 7.557 2.21 9.054 0 14-7.497 14-13.987 0-.21 0-.42-.016-.63.962-.69 1.8-1.56 2.46-2.548l-.046-.02z"/>' +
'</svg>' +
'</button>';

$.fancybox.defaults.btnTpl.wapp = '<button data-fancybox-wapp class="fancybox-button fancybox-button--wapp" title="Whatsapp">' +
'<svg viewBox="0 0 512 512">'+
'<path d="m256 0c-140.609375 0-256 115.390625-256 256 0 46.40625 12.511719 91.582031 36.238281 131.105469l-36.238281 124.894531 124.894531-36.238281c39.523438 23.726562 84.699219 36.238281 131.105469 36.238281 140.609375 0 256-115.390625 256-256s-115.390625-256-256-256zm160.054688 364.167969-11.910157 11.910156c-16.851562 16.851563-55.605469 15.515625-80.507812 10.707031-82.800781-15.992187-179.335938-109.5625-197.953125-190.59375-9.21875-40.140625-4.128906-75.039062 9.183594-88.355468l11.910156-11.910157c6.574218-6.570312 17.253906-6.5625 23.820312 0l47.648438 47.652344c3.179687 3.179687 4.921875 7.394531 4.921875 11.90625s-1.742188 8.730469-4.921875 11.898437l-11.90625 11.921876c-13.125 13.15625-13.125 34.527343 0 47.652343l78.683594 77.648438c13.164062 13.164062 34.46875 13.179687 47.652343 0l11.910157-11.90625c6.148437-6.183594 17.632812-6.203125 23.832031 0l47.636719 47.636719c6.46875 6.441406 6.714843 17.113281 0 23.832031zm0 0"/>'+
'</svg>'+
'</button>';

$.fancybox.defaults.btnTpl.email = '<button data-fancybox-email class="fancybox-button fancybox-button--email" title="Email">' +
'<svg viewBox="0 0 512 512">'+
'<path d="M10.688,95.156C80.958,154.667,204.26,259.365,240.5,292.01c4.865,4.406,10.083,6.646,15.5,6.646 c5.406,0,10.615-2.219,15.469-6.604c36.271-32.677,159.573-137.385,229.844-196.896c4.375-3.698,5.042-10.198,1.5-14.719 C494.625,69.99,482.417,64,469.333,64H42.667c-13.083,0-25.292,5.99-33.479,16.438C5.646,84.958,6.313,91.458,10.688,95.156z"/>'+
'<path d="M505.813,127.406c-3.781-1.76-8.229-1.146-11.375,1.542c-46.021,39.01-106.656,90.552-152.385,129.885 c-2.406,2.063-3.76,5.094-3.708,8.271c0.052,3.167,1.521,6.156,4,8.135c42.49,34.031,106.521,80.844,152.76,114.115 c1.844,1.333,4.031,2.01,6.229,2.01c1.667,0,3.333-0.385,4.865-1.177c3.563-1.823,5.802-5.49,5.802-9.49V137.083 C512,132.927,509.583,129.146,505.813,127.406z"/>'+
'<path d="M16.896,389.354c46.25-33.271,110.292-80.083,152.771-114.115c2.479-1.979,3.948-4.969,4-8.135 c0.052-3.177-1.302-6.208-3.708-8.271C124.229,219.5,63.583,167.958,17.563,128.948c-3.167-2.688-7.625-3.281-11.375-1.542 C2.417,129.146,0,132.927,0,137.083v243.615c0,4,2.24,7.667,5.802,9.49c1.531,0.792,3.198,1.177,4.865,1.177 C12.865,391.365,15.052,390.688,16.896,389.354z"/>'+
'<path d="M498.927,418.375c-44.656-31.948-126.917-91.51-176.021-131.365c-4-3.26-9.792-3.156-13.729,0.24 c-9.635,8.406-17.698,15.49-23.417,20.635c-17.563,15.854-41.938,15.854-59.542-0.021c-5.698-5.135-13.76-12.24-23.396-20.615 c-3.906-3.417-9.708-3.521-13.719-0.24c-48.938,39.719-131.292,99.354-176.021,131.365c-2.49,1.792-4.094,4.552-4.406,7.604 c-0.302,3.052,0.708,6.083,2.802,8.333C19.552,443.01,30.927,448,42.667,448h426.667c11.74,0,23.104-4.99,31.198-13.688 c2.083-2.24,3.104-5.271,2.802-8.323C503.021,422.938,501.417,420.167,498.927,418.375z"/>'+
'</svg>'+
'</button>';


$(window).on('load', function(){
  $("a#fancybox").fancybox({
    loop: true,
    parentEl: '.fancybox-wrapper',
    transitionDuration: 100,
    animationDuration: 500,
    animationEffect: "fade",
    buttons: [
    'fb',
    'wapp',
    'email',
    "zoom",
    "zoom-in-out",
    "fullScreen",
    "slideShow",
    "close"
    ],
    infobar: true,
    transitionEffect: "slide",
    thumbs: {
      autoStart: false, // Display thumbnails on opening
      hideOnClose: true, // Hide thumbnail grid when closing animation starts
      parentEl: ".fancybox-container", // Container is injected into this element
      axis: "y" // Vertical (y) or horizontal (x) scrolling
    },
    clickContent: function(current, event) {
      return current.type === "image" ? "next" : false;
    }
  });
})


// $("#fancybox").fancybox({
//   loop: true,
//   parentEl: '.fancybox-wrapper',
//   transitionDuration: 100,
//   animationDuration: 500,
//   animationEffect: "fade",
//   buttons: [
//     'fb',
//     'wapp',
//     'email',
//     "zoom",
//     "zoom-in-out",
//     "fullScreen",
//     "slideShow",
//     "thumbs",
//     "close"
//   ],
//   infobar: true,
//   transitionEffect: "slide",
//   thumbs: {
//     autoStart: false, // Display thumbnails on opening
//     hideOnClose: true, // Hide thumbnail grid when closing animation starts
//     parentEl: ".fancybox-container", // Container is injected into this element
//     axis: "y" // Vertical (y) or horizontal (x) scrolling
//   },
//   clickContent: function(current, event) {
//     return current.type === "image" ? "next" : false;
//   }
// });

$(document).on('click', '.product-gallery__image', function(e){
//     currentSlide($(this).data('zoom-index'));
//     $('.image-zoom-modal').css('visibility', 'visible');
//     $('.image-zoom-modal').css('opacity', '1');
//     $('.image-zoom-modal').show();
//   	$("html").css('overflow', 'hidden');
});

$(document).on('click', '.image-zoom-modal .close', function(){
//     $('.image-zoom-modal').hide();
//     $("html").css('overflow', 'auto');
})


$(".header__action-item.header__action-item--locale").on('click', function(){
  location.href = $(this).find('span').data('href');
})

var msg_content = '';
$("textarea#contact-form-message").on('keydown', function(evt){
  var text_count = $(this).val().length;
  if(evt.keyCode == 8){
  	text_count --;
    if(text_count == -1){
      text_count = 0;
    }
  }
  else {
    text_count ++;
  }
  if(text_count == 2000){
    msg_content = $(this).val();
  }
  
  if(text_count > 2000) {
    $(this).val(msg_content);
  }
  else {
    $(".character_count dd.count").html(text_count);
  }
})

$(".card .card__title.heading").on('click', function(){
  var handle = $(this).attr('collapsed');
  if(handle == 'true'){
    $(".card .card__section.technical-specifications-section").slideDown(function(){$(this).css('display', 'inline-block')});
    $(this).attr('collapsed', 'false');
  }
  else {
    $(".card .card__section.technical-specifications-section").slideUp();
    $(this).attr('collapsed', 'true');
  }
})

$("body").on('click', 'span.body_overlay', function(){
  $(".header__mobile-nav-toggle").click();
});

$(document).ready(function(){
  $("body").on('click', '.mobile-menu__subnav-link', function(evt){
    var target = $(this).next(".mobile-menu__nav-collapsible");
    var handle = target.attr("data-open");
    if(handle == 'false'){
      target.attr('data-open', 'true');
      $(this).attr('aria-expanded', "true");
    }
    else {
      target.attr('data-open', 'false');
      $(this).attr('aria-expanded', "false");
    }
  })

  $("body").on('click', 'span.body_overlay', function(){
    $(".mobile-menu__nav-collapsible[data-open='true']").attr('data-open', 'false');
    $('.mobile-menu__nav-link, .mobile-menu__subnav-link').attr('aria-expanded', false);
  })
  
  $("body").on('click', 'button.mobile-menu__back-button[data-index="2"]', function(){
    $(this).parents('.mobile-menu__nav-collapsible').attr('data-open', 'false');
  })
  
  $('.slider_arrow_wrapper .slide_arrow.slide_next').on('click', function(){
    $(this).parents('.scroller__inner').find('.lSNext').click();
  })
  
  $('.slider_arrow_wrapper .slide_arrow.slide_prev').on('click', function(){
    $(this).parents('.scroller__inner').find('.lSPrev').click();
  })
  
  $('.accordion_content:not(.active)').hide()
    //----- click function
    $("#accordion").find(".accordion_tab").click(function() { 
      $("#accordion").find(".accordion_tab").removeClass('active');
      $('.accordion_content').slideUp('fast');
      var selected = $(this).next('.accordion_content');
      if (selected.is(":hidden")) {
        $(this).next('.accordion_content').slideDown('fast');
        $(this).toggleClass('active');
      }
    });

//   var _popover_handle = false;
//   $(".header__action-list .header__action-item--account a.header__account-icon").on('click', function(){
//     var handle = $(this).attr('aria-expanded');
//     if(handle == 'false'){
//       $(this).attr('aria-expanded', 'true');
//       $(this).next('#account-popover').attr('aria-hidden', 'false');
//       _popover_handle = true;
//     }
//     else {
//       _popover_handle = false;
//       $(this).attr('aria-expanded', 'false');
//       $(this).next('#account-popover').attr('aria-hidden', 'true');
//     }
//   })


})




//
// LANGIFY FIX
//
$(document).ready(function() {
  $("body").on("click", ".langify_ar_js", function(e) {
    e.preventDefault();
    var url = $(this).attr("data-href").replace('__', '');
    document.location.href = url;
  });
});


//
// STICKY ADD CART BUTTON
//
$(document).ready(function() {
  if ( $(".js_sticky_line").length ) {

    var navPos, winPos;
    
    function refreshVar() {
      navPos = $('.js_sticky_line').offset().top - 70;
    }

    refreshVar();
    $(window).resize(refreshVar);

    
    $(window).scroll(function() {
      if ( $(window).width() < 640 && $("body").hasClass("template-product") ) {

        winPos = $(window).scrollTop();

        if (winPos >= navPos) {
          $('body').addClass('addCart_fixed');  
        }  else {
          $('body').removeClass('addCart_fixed');
        }
      }
    });
  }



  $("body").on("click", ".sticky_addCart_button_js", function(e) {
    e.preventDefault();
    $(".product-form__payment-container button[type='submit']")[0].click();
    $('html, body').animate({ scrollTop: 0 }, 700);  
  });

});







//
// MOBILE COLLECTION SORT
//
$(document).ready(function() {
  $("body").on("click", ".value-picker__inner_js", function(e) {
    e.preventDefault();
    if ( $(window).width() <= 640 ) {
      $("#sort-by-toggler")[0].click();
    } 
  });
});



//
// mini cart sticky submit
//
$("body").on("click submit", ".mini_cart_bot_fix button[type='submit']", function(e) {
  e.preventDefault();
  $("#mini-cart button[type='submit']")[0].click();
});




//
// hide map info - order page
//
$(document).ready(function() {
  if ( $(".address_hide_googleMap_js").length ) {
      var text = $(".address_hide_googleMap_js").html();
      text = text.replace('00000<br>', '').replace('00000', '');
      text = text.replace( localStorage.getItem('ls_location')+'<br>', '');
      text = text.replace( localStorage.getItem('ls_location'), '');
      var text_arr = text.split('<br>');
      var finish_text = '';
      for (var i = 0; i < text_arr.length; i++) {
        if ( text_arr[i].indexOf('http://maps.google.com/maps?q=') !== -1 ) {

        } else {
          if ( finish_text == '') {
            finish_text = text_arr[i];
          } else {
            finish_text = finish_text + '<br>' + text_arr[i];
          }
        }
      }
      $(".address_hide_googleMap_js").html(finish_text);
  }
});


//
// cart_json
//
var cart_json = {};
jQuery(document).ready(function() {
  if ( $(".cart_json").length > 0 ) { 
    cart_json = $(".cart_json").text();
    localStorage.setItem('cart_json', cart_json);
  }
});

//
// LIMIT TOTAL PRICE
//
function limit_total_price (item_price) {
  var cart_json = localStorage.getItem('cart_json');
  cart_json = JSON.parse(cart_json);

  var total_price_MAX = window.theme.total_price_limit * 100;
  var total_price = Number(cart_json.total_price) + Number(item_price);


  if ( total_price_MAX < total_price) {
    return false;
  } else {
    return true;
  }

}






// =====================================================================================================================
//   SEARCH PAGE MOBILE
// =====================================================================================================================
// FILTER
$("body").on("click", ".snize-main-panel-controls", function(e) {
  if ( $(document).width() < 768 ) {
    $(".snize-main-panel-mobile-filters a")[0].click();
    $(".snize-product-filters-title").addClass("open");
    $(".snize-product-filters-title + .snize-product-filters-list").show();
    $("body").addClass("body_SearctDrawer_filter");
  }
});
$("body").on("click touchstart", ".SearctDrawer_Filter_js__Close, .snize-product-filters-title", function(t) {
  if ( $(document).width() < 768 ) {
    $(".snize-close-button")[0].click();
    $("body").removeClass("body_SearctDrawer_filter");
  }
});
// SORT
$("body").on("click", ".snize-main-panel-dropdown", function(t) {
  if ( $(document).width() < 768 ) {
    $("body").addClass("body_SearctDrawer_sort");
  }
}); 
$("body").on("click touchstart", ".SearctDrawer_Sort_js__Close, .snize-sortby-title", function(t) {
  if ( $(document).width() < 768 ) {
    $("body").removeClass("body_SearctDrawer_sort");
  }
}); 


// =====================================================================================================================
//   SEARCH BG
// =====================================================================================================================
$("body").on("click", ".header_search_bg_js", function(e) {
  $(".header__search-bar-wrapper_2 a.header__action-item-link[href='/search']")[0].click();
});


// =====================================================================================================================
//   TABS
// =====================================================================================================================
$(document).ready(function () {
  $("body").on("click", ".pt_2_content_accordion h4", function () {
    $(this).closest(".item").toggleClass("open");
    $(this).closest(".item").find(".text").slideToggle();
  });


  $("body").on("click", ".pt_2_tab_title_js", function () {
    var id = $(this).attr("data-id");
    $(".pt_2_tab_text_js").hide();
    $(".pt_2_tab_text_js[data-id='" + id + "']").show();

    $(".pt_2_tab_title_js").removeClass("active");
    $(this).addClass("active");

    $(".pt_2_content_tabs_content_all").slideDown();
    $(".pt_2_content_tabs_arrow_js").removeClass("active");
  });

  $("body").on("click", ".pt_2_content_tabs_arrow_js", function () {
    $(this).toggleClass("active");
    $(".pt_2_content_tabs_content_all").slideToggle();

  });

});//end ready